/* One registration offer per order. Shopify remains the source of cart totals. */
(function () {
  'use strict';
  if (window.KD_COUPON) return;
  var key = 'kokochi-newsletter-offer-v2', code = 'KOKOCHI2000', entryKey = 'kokochi-entry-offer-shown-v1', cartKey = 'ec-coupon-cart-kokochi';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var eligible = false, applied = false, pending = null, lastFocus = null, offerRevision = 0;
  try { eligible = localStorage.getItem(key) === 'yes'; } catch (_) {}
  if (window.EC_SPECIAL_OFFER && window.EC_SPECIAL_OFFER.current()) eligible = true;
  function notify(value) {
    applied = value;
    document.dispatchEvent(new CustomEvent('kd:offer-state', { detail: { applied: applied } }));
  }
  function forget() { eligible = false; try { localStorage.removeItem(key); localStorage.removeItem(cartKey); } catch (_) {} notify(false); }
  function remember() { eligible = true; try { localStorage.setItem(key, 'yes'); } catch (_) {} try { syncReopen(); } catch (_) {} }
  function offerAmount() { return window.EC_OFFER_AMOUNT ? window.EC_OFFER_AMOUNT() : 2000; }
  // Keep every existing code, including identity-restricted codes awaiting checkout email.
  function mergeCodes(cart, selected, removeOwn) {
    var result = [], seen = {};
    (cart.discount_codes || []).map(function(entry) { return String(entry.code || ''); }).concat(selected ? [selected] : []).forEach(function(value) {
      var normalized = value.toUpperCase();
      if (!value || (removeOwn(value) && normalized !== String(selected || '').toUpperCase()) || seen[normalized]) return;
      seen[normalized] = true; result.push(value);
    });
    return result.join(',');
  }
  async function readCart() {
    var response = await fetch(root + 'cart.js', { cache: 'no-store' });
    if (!response.ok) throw Error('Cart could not be loaded');
    return response.json();
  }
  function allocationAmount(cart, selected) {
    var total = 0, found = false, wanted = String(selected).toUpperCase();
    function matches(application) { return application && String(application.code || application.title || '').toUpperCase() === wanted; }
    (cart.items || []).forEach(function(item) {
      (item.line_level_discount_allocations || []).forEach(function(allocation) {
        if (matches(allocation.discount_application) && Number.isFinite(Number(allocation.amount))) { total += Number(allocation.amount); found = true; }
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function(entry) {
      var application = entry.discount_application || entry;
      var amount = entry.amount != null ? entry.amount : application.total_allocated_amount;
      if (matches(application) && amount != null && Number.isFinite(Number(amount))) { total += Number(amount); found = true; }
    });
    return found ? total : null;
  }
  function inspectOffer(cart, selected, productId) {
    var target = (cart.items || []).filter(function(item) { return Number(item.product_id) === productId; });
    var units = target.reduce(function(n,item) { return n + (Number(item.quantity) || 0); },0);
    var active = (cart.discount_codes || []).filter(function(entry) { return entry.applicable; });
    var usable = active.some(function(entry) { return String(entry.code).toUpperCase() === String(selected).toUpperCase(); });
    var expected = offerAmount() * 100 * units;
    var actual = allocationAmount(cart, selected);
    if (actual === null && usable && active.length === 1 && Number(cart.total_discount) === expected) actual = expected;
    var mismatch = units && usable && actual !== null && actual !== expected;
    active.forEach(function(entry) {
      if (!/^K[RF]3-[a-f0-9]{20}$/i.test(String(entry.code))) return;
      var value = allocationAmount(cart, entry.code);
      // Shopify can cap a fixed discount at the remaining subtotal.
      if (value !== null && value !== Math.min(300000, Number(cart.total_price) + value)) mismatch = true;
    });
    if (mismatch) {
      try { if (window.EC_MEASURE) window.EC_MEASURE.event('coupon_mismatch'); } catch (_) {}
      throw Error('Offer amount mismatch');
    }
    // An absent/inapplicable code can require checkout identity. It is not verified,
    // but it must not prevent the buyer from entering their email at checkout.
    return !!(units && usable && actual === expected);
  }
  function owns(value) { return ['KOKOCHI4000', 'KOKOCHI2000', code.toUpperCase(), 'K-SUMMER-9435803F'].indexOf(String(value).toUpperCase()) >= 0; }
  function check(cart) {
    var verified = inspectOffer(cart, code, 9283999465610);
    notify(verified);
    if (verified) { try { localStorage.setItem(cartKey, JSON.stringify({ token: String(cart.token || '').split('?')[0], at: Date.now() })); } catch (_) {} }
    return cart;
  }
  function refreshCode() {
    var special = window.EC_SPECIAL_OFFER && window.EC_SPECIAL_OFFER.current();
    code = special ? special.code : 'KOKOCHI2000';
  }
  function verify(cart) { refreshCode(); return check(cart); }
  function verificationKey() { refreshCode(); return code + ':' + offerAmount() + ':' + offerRevision; }
  async function apply(options) {
    if (!eligible) return null;
    refreshCode();
    if (pending) {
      // A page-entry request may predate a just-added item; finish it before
      // applying again so checkout always validates the current cart.
      try { await pending; } catch (_) {}
      return apply(options);
    }
    offerRevision++;
    pending = (async function () {
      var current = options && options.cart || await readCart();
      var discount = mergeCodes(current, code, owns);
      var response = await fetch(root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(options && options.sections === false ? { discount: discount } : { discount: discount, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname })
      });
      if (!response.ok) throw Error('Offer could not be applied');
      var cart = check(await response.json()); return cart;
    })();
    try { return await pending; } catch (error) { notify(false); throw error; } finally { pending = null; }
  }
  function closePopups() {
    document.querySelectorAll('.sign-up-popup-modal,.success-popup-modal').forEach(function (node) { node.classList.remove('popup-modal--active'); });
    document.querySelectorAll('.sign-up-popup-overlay,.success-popup-overlay').forEach(function (node) { node.classList.remove('popup-overlay--active'); });
    if (lastFocus && lastFocus.isConnected) lastFocus.focus();
  }
  function openPopup(success) {
    lastFocus = document.activeElement;
    closePopups();
    var modal = document.querySelector(success ? '.success-popup-modal' : '.sign-up-popup-modal');
    var overlay = document.querySelector(success ? '.success-popup-overlay' : '.sign-up-popup-overlay');
    if (!modal || !overlay) return;
    modal.classList.add('popup-modal--active'); overlay.classList.add('popup-overlay--active');
    modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', success ? '登録特典' : 'メール登録で2,000円OFF');
    var focus = modal.querySelector(success ? 'button' : 'input[type=email]');
    if (focus) focus.focus({ preventScroll: true });
  }
  function status(message) {
    var node = document.querySelector('.success-popup-modal .popup-modal__success-msg');
    if (node) { node.textContent = message; node.style.display = 'block'; node.setAttribute('role', 'status'); }
  }
  async function signupSuccess() {
    try { if (window.EC_MEASURE) window.EC_MEASURE.event('newsletter_confirmed'); } catch (_) {} 
    remember();
    try { localStorage.setItem('promo-bar-subscribed-' + location.host, JSON.stringify({ subscribed: true })); } catch (_) {}
    openPopup(true); status('登録が完了しました。特典を適用しています…');
    var button = document.querySelector('.success-popup-modal .popup-modal__copy-btn');
    if (button) button.disabled = true;
    try {
      var cart = await apply();
      if (window.KD_CART_SYNC) await window.KD_CART_SYNC.refresh(cart);
      status(applied ? 'この注文に登録特典を適用しました。' : '登録が完了しました。割引の適用条件と金額は購入手続きでご確認ください。');
      if (button) button.textContent = 'お買い物を続ける';
    } catch (_) { status('特典を適用できませんでした。下のボタンから再試行できます。'); if (button) button.textContent = 'もう一度適用する'; }
    finally { if (button) button.disabled = false; }
  }
  function showError(form) {
    var target = form || document.querySelector('cart-drawer'); if (!target) return;
    var message = target.querySelector('.kd-offer-error');
    if (!message) { message = document.createElement('p'); message.className = 'kd-offer-error'; message.setAttribute('role', 'alert'); target.appendChild(message); }
    message.textContent = '登録特典を確認できませんでした。再試行するか、この特典を外して購入手続きへ進めます。';
    if (target.querySelector('.kd-offer-fallback')) return;
    var button = document.createElement('button'); button.type = 'button'; button.className = 'button button--secondary kd-offer-fallback'; button.textContent = 'この登録特典を外して購入手続きへ'; target.appendChild(button);
    button.addEventListener('click', async function () {
      button.disabled = true;
      try {
        var current = await readCart();
        var response = await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: mergeCodes(current, '', owns) }) });
        if (!response.ok) throw Error('Could not remove offer');
        var cart = await response.json(); if ((cart.discount_codes || []).some(function(entry) { return entry.applicable && owns(entry.code); })) throw Error('Offer remains applied');
        eligible = false; if (window.EC_SPECIAL_OFFER) window.EC_SPECIAL_OFFER.clear(); try { localStorage.removeItem(key); } catch (_) {} notify(false); try { if (window.EC_MEASURE) window.EC_MEASURE.event('checkout_redirect'); } catch (_) {} location.href = root + 'checkout';
      } catch (_) { message.textContent = '購入手続きに進めませんでした。もう一度お試しください。'; }
      finally { button.disabled = false; }
    });
  }
  window.KD_COUPON = { amount: offerAmount, apply: apply, verify: verify, verificationKey: verificationKey, isPending: function () { return !!pending; }, remember: remember, forget: forget, signupSuccess: signupSuccess, isApplied: function () { return applied; }, isEligible: function () { return eligible; } };
  var registering = new WeakSet();
  document.addEventListener('submit', async function (event) {
    var form = event.target, button = event.submitter;
    // 2026-09-07: 登録フォームはShopifyのreCAPTCHAトークン注入が要るため通常送信（再読込後に data-kd-newsletter-success で成功処理）
    if (form.matches('.newsletter-form') && form.querySelector('[name="contact[email]"]')) return;
    if (!eligible || !button || button.name !== 'checkout') return;
    event.preventDefault(); event.stopImmediatePropagation(); button.disabled = true;
    try { await apply(); try { if (window.EC_MEASURE) window.EC_MEASURE.event('checkout_redirect'); } catch (_) {} location.href = root + 'checkout'; }
    catch (_) { button.disabled = false; showError(form); }
  }, true);
  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest('button,a,.popup-overlay'); if (!target) return;
    if (window.EC_COUPON_FLOW && target.matches('.kd-offer-reopen,.popup-modal__close,.popup-modal__dismiss-btn,.sign-up-popup-overlay,.success-popup-overlay,.success-popup-modal .popup-modal__copy-btn')) return;
    if (target.matches('.kd-offer-reopen')) { event.preventDefault(); openPopup(eligible); if (eligible) status(applied ? 'この注文に2,000円OFFを適用できます。' : '下のボタンから登録特典を適用できます。'); return; }
    if (target.matches('.popup-modal__close,.popup-modal__dismiss-btn,.sign-up-popup-overlay,.success-popup-overlay')) { closePopups(); return; }
    if (target.matches('.success-popup-modal .popup-modal__copy-btn')) { event.preventDefault(); if (applied) closePopups(); else signupSuccess(); return; }
    if (!eligible || !target.matches('a[href]') || new URL(target.href).pathname !== '/checkout') return;
    event.preventDefault(); event.stopImmediatePropagation(); apply().then(function () { location.href = target.href; }).catch(function () { showError(); });
  }, true);
  document.addEventListener('keydown', function (event) {
    if (window.EC_COUPON_FLOW) return;
    var modal = document.querySelector('.popup-modal--active'); if (!modal) return;
    if (event.key === 'Escape') { closePopups(); return; }
    if (event.key !== 'Tab') return;
    var nodes = [].filter.call(modal.querySelectorAll('button,input,a[href]'), function (n) { return !n.disabled && n.offsetParent !== null; });
    var first = nodes[0], last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  function syncReopen() {
    if (window.EC_COUPON_FLOW) return;
    var signup = document.querySelector('.sign-up-popup-modal');
    if(eligible && signup && signup.classList.contains('popup-modal--active')) { signup.classList.remove('popup-modal--active'); var overlay = document.querySelector('.sign-up-popup-overlay'); if(overlay) overlay.classList.remove('popup-overlay--active'); }

    var trigger = document.querySelector('.kd-offer-reopen');
    var active = document.querySelector('.sign-up-popup-modal.popup-modal--active,.success-popup-modal.popup-modal--active');
    if (trigger) {
      trigger.hidden = !!eligible; /* 2026-09-07 本人指定: メール登録済みの人には右下の再表示ボタンを出さない */
      trigger.setAttribute('aria-expanded', String(!!active));
      if (active) { if (!active.id) active.id = active.matches('.success-popup-modal') ? 'kd-offer-success' : 'kd-offer-signup'; trigger.setAttribute('aria-controls', active.id); }
    }
  }
  function entryOffer() {
    if(eligible || !document.querySelector('.sign-up-popup-modal')) return;
    try { if(sessionStorage.getItem(entryKey)==='yes') return; sessionStorage.setItem(entryKey,'yes'); } catch(_) {}
    openPopup(false);
  }
  function ready() {
    if (window.EC_COUPON_FLOW) return;
    var shell = document.querySelector('.kd-promo-shell');
    try {
      var previousSignup = JSON.parse(localStorage.getItem('promo-bar-subscribed-' + location.host) || 'null');
      if(previousSignup && previousSignup.subscribed === true) remember();
    } catch(_) {}
    if(shell && shell.dataset.kdNewsletterRegistered === 'true') remember();
    document.querySelectorAll('.sign-up-popup-modal,.success-popup-modal').forEach(function(modal){ new MutationObserver(syncReopen).observe(modal, { attributes:true, attributeFilter:['class'] }); });
    syncReopen();
    if(document.querySelector('[data-kd-newsletter-success]')) { signupSuccess(); return; }
    if(eligible) apply().then(function(cart){ if(window.KD_CART_SYNC) return window.KD_CART_SYNC.refresh(cart); }).catch(function(){});
    else entryOffer();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true }); else ready();
})();
